import { useMemo } from "react";
import { useAuthenticated } from "../auth";
import { portalServer } from "../config";
import {
  useSyncData,
  useSyncModuleRegistration,
  type SyncModule,
} from "../sync";
import type { ServerResource } from "../types";
import { daily } from "./provider";

const syncModuleId = "resources";

function useResourcesSyncModule(): SyncModule<ReadonlyArray<ServerResource>> {
  const { portalKey } = useAuthenticated();

  return useMemo(
    () => ({
      id: syncModuleId,
      i18nKey: `tableau:tasks.${syncModuleId}`,
      defaultOptions: {
        schedule: { type: "periodic", interval: daily },
      },
      fetchData: async () => {
        const response = await fetch(
          `${portalServer}/get-resources.php?ORG_ACCESSKEY=${encodeURIComponent(
            portalKey,
          )}`,
        );

        if (!response.ok) {
          throw new Error(
            `Error fetching data: ${response.status} ${response.statusText}`,
          );
        }

        const data = await response.json();
        return data.RESOURCE_LIST ?? [];
      },
    }),
    [portalKey],
  );
}

export function useResourcesSync() {
  const module = useResourcesSyncModule();
  useSyncModuleRegistration(module);
}

export function useResources(): ReadonlyArray<ServerResource> {
  return useSyncData(syncModuleId) ?? [];
}
